import { Component, Input } from '@angular/core';
import { Globals } from '../../../globals';
import { ToastController, NavController, NavParams, LoadingController } from 'ionic-angular';
import { OrdersCoServices } from '../../orders/services';
import { TpvRoomPage } from '../../tpv/tpv-select/tpv-select';
import { OrdersRoomPage } from '../../orders/orders-rooms/orders-rooms';
import { ConfigurationServices } from '../../configuration/services';
import { ConfigurationUsersScreenBlockPage } from '../../configuration/configuration-users-screen-block/configuration-users-screen-block';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'block-screen',
  templateUrl: 'block-screen.html'
})
export class BlockScreenPage {
  @Input() screen_show: boolean = true;
  type: any;
  k_blockscreen: any;
  users: any;

  constructor(public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public loadingCtrl: LoadingController,
    public translate: TranslateService) {

    this.type = this.navParams.get('type');
    this.getUsersScreenBlock();

  }

  async getUsersScreenBlock() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.users = await this.configurationServices.getUsersScreenBlockAsync(this.globals.restaurant_uid);
    loadingPopup.dismiss();
  }

  state: boolean = false;
  user: any;
  async enter() {
    if (this.ordersCoServices.keyboard_blockscreen) {
      this.k_blockscreen = this.ordersCoServices.keyboard_blockscreen;
    }

    for (let _user of this.users) {
      if (_user.code == this.k_blockscreen) {
        this.user = _user;
        this.state = true;
      }
    }

    if (this.state) {
      let toast = this.toastCtrl.create({
        message: "¡" + this.translate.instant('general-bienvenido') + " " + this.user.name,
        duration: 3000,
        position: 'top'
      });
      toast.present();

      //reset and set data
      this.ordersCoServices.keyboard_blockscreen = '';
      this.globals.waiter = this.user.name;
      this.globals.waiter_uid = this.user.uid;

      if (this.type == 'orders') {
        this.globals.side_menu_active = 'order';
        this.navCtrl.setRoot(OrdersRoomPage);
      } else {
        this.globals.side_menu_active = 'tpv';
        this.navCtrl.setRoot(TpvRoomPage);
      }


    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-error-codigo-acceso-incorrecto'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.ordersCoServices.keyboard_blockscreen = '';
    }

    this.ordersCoServices.deleteKeyboardBlockscreen();
    this.ordersCoServices.deleteKeyboard();
    this.k_blockscreen = '';

  }

  toCreateUsersScreenBlock() {
    this.navCtrl.setRoot(ConfigurationUsersScreenBlockPage);
    this.globals.side_menu_config_active = 'users_block_screen';
  }

  public onBack() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/block-screen/block-screen.ts